import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=3d0f54e2&scoped=true&component=true&componentId=indexcae6158a"
import script from "./index.mpx?vue&type=script&lang=js&component=true&componentId=indexcae6158a"
export * from "./index.mpx?vue&type=script&lang=js&component=true&componentId=indexcae6158a"
import style0 from "./index.mpx?vue&type=style&index=0&id=3d0f54e2&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22mcae6158a%22%7D&component=true&componentId=indexcae6158a"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0f54e2",
  null
  
)

export default component.exports